<template>
  <div>
    <div class="">
      <small class="float-right"> <i>Available in 5 days</i> </small> <br />
    </div>
    <b-tabs justified lazy>
      <b-tab>
        <template #title>
          <router-link v-if="vinNumber" :to="vehiclePageURL">
            {{ vehicleModel }}
          </router-link>

          <span v-else> {{ vehicleModel }}</span>
        </template>
        <!--  <slot name="top" />
        <div class="scroll">
          <img
            v-for="(src, index) in exterior"
            :src="
              imgError && imgsNotFound.find((e) => e === index) ? imgError : src
            "
            class="gallery-img img-thumbnail"
            @click="selectImage(index, src)"
            :key="`auto-exterior-${index}`"
            :style="size ? size : 'width: auto'"
            @error="errorLoadImg(index)"
          />
        </div> -->

        <lingallery
          v-if="images.length > 0"
          :addons="{ enableLargeView: true }"
          :iid.sync="currentId"
          :width="width"
          :height="height"
          :items="images"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
/* import { isMobile } from "mobile-device-detect";
 */ import Lingallery from "lingallery";

export default {
  name: "CarGallery",
  components: { Lingallery },
  props: [
    "mainPhoto",
    "exterior",
    "interior",
    "damages",
    "size",
    "classImg",
    "damagesDots",
    "vehicleModel",
    "vinNumber",
    "make",
    "model",
  ],
  data() {
    return {
      /*       interiorDots: [],
      exteriorDots: [], */
      /*       currentDamage: null,
       */ isSmall: false,
      imgError: "",
      width: 600,
      height: 180,

      imgsNotFound: [],
      /*  images: [
        {
          id: "someid1",
          src: this.imgError,
          thumbnail: this.imgError,
        },
      ], */
      currentId: "someid1",
    };
  },
  computed: {
    vehiclePageURL() {
      return "/vehicle/" + this.vinNumber + "-" + this.make + "-" + this.model;
    },
    images() {
      if (this.exterior.length === 0) {
        return this.formatImages(this.interior);
      } else {
        return this.formatImages(this.exterior);
      }
    },
  },

  methods: {
    /*   selectImage(index, src) {
      if (!src) return;
      let imgNotFound = this.imgsNotFound.filter((i) => i === index);
      this.$emit("onSelectImage", {
        index,
        src,
        tab: this.tab,
        imgNotFound: imgNotFound.length ? true : false,
      });
    }, */

    /*    clickDamageDot(dot) {
      this.currentDamage = dot;
      if (isMobile || this.isSmall) {
        this.$bvModal.show("damage-modal");
        this.$store.commit("companyCars/setDamageImageModal", dot.damagePhoto);
      }
    }, */
    vehicleDetails() {
      this.$parent.openVehicleDetails(this.vehicle);
      this.$parent.setImages();
    },
    errorLoadImg(index) {
      this.imgsNotFound.push(index);
      this.imgError = require("@/assets/img/image_not_found.png");
    },
    formatImages(images) {
      return images.map((image) => {
        return {
          id: image.photo,
          src: image.photo,
          largeViewSrc: image.photo,
          thumbnail: image.photoThumbnail || image.photo,
        };
      });
    },
  },
  mounted() {
    /*  if (this.exterior.length === 0) {
      this.images = this.formatImages(this.interior);
    } else {
      this.images = this.formatImages(this.exterior);
    } */

    window.addEventListener("resize", (e) => {
      e.target.innerWidth <= 1648
        ? (this.isSmall = true)
        : (this.isSmall = false);
    });
    setTimeout(() => {
      this.damagesDots?.forEach((dot) => {
        if (dot.type === "interior") {
          this.interiorDots.push(dot);
        } else {
          this.exteriorDots.push(dot);
        }
      });
    }, 500);
  },
};
</script>
<style scoped>
.img-damage {
  max-height: 100%;
  width: auto;
  display: inline-block;
  float: none;
}
.scroll {
  overflow-x: auto;
  white-space: nowrap;
}
img {
  cursor: pointer;
}
@media (max-width: 300px) {
  .gallery-img {
    height: 10px !important;
  }
}
button.pswp__button.pswp__button--arrow--left::before {
  background-color: red !important;
}
.pswp__button--arrow--left:before {
  background-color: red !important;
}
</style>
